module.exports = __webpack_public_path__ + "img/theater_round_14.fd6aca24.png";